import '@babel/runtime/helpers/extends';
import 'react';
import '@emotion/react';
import SvgSuperbottleGlyphSecondary from './svgs/SuperbottleGlyphSecondary.js';
import SvgSuperbottleGlyph from './svgs/SuperbottleGlyph.js';
import { useIcon } from '../../shared-components/icon/index.js';

var superbottleGlyph = (props => useIcon(SvgSuperbottleGlyph, SvgSuperbottleGlyphSecondary, props));

export { superbottleGlyph as default };
